import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MoreIcon from '@mui/icons-material/MoreVert';
import { useMsal } from "@azure/msal-react";
import { useEffect } from 'react';
import protec_logo_white from "../NavBar/logo_white_red.png";
import { FormControl, InputLabel, Select } from '@mui/material';
import { getAppLanguage, setAppLanguage } from "../../../src/utils/lanungeConfig";
import en_flag from "../../assets/flags/en.png"
import pl_flag from "../../assets/flags/poland.png"
import de_flag from "../../assets/flags/de.png"
import { useTranslation } from 'react-i18next';
// import { LanguagePicker } from './languagePicker/LanguagePicker';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const handleLogout = (logoutType, instance) => {
  
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }

  };

export default function PrimarySearchAppBar({isAuthenticated, accountName, setOpen}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);


  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { instance } = useMsal();

  const [language, setLanguage] = React.useState("");

  const { t } = useTranslation();


  useEffect(() => {
    const appLanguge = getAppLanguage();
    setLanguage(appLanguge);
  }, []);

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    setAppLanguage(event.target.value);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={()=>handleLogout("popup", instance)}>Log Out</MenuItem>
    </Menu>
  );
  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
    

     {isAuthenticated &&
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Logout</p>
      </MenuItem>
    }
    </Menu>
  );

  return (

    <Box sx={{ flexGrow: 1 }}>
    <AppBar position="static" sx={{ backgroundColor: 'black' }} enableColorOnDark={true}>
      <Toolbar>
        <Box
          component="img"
          src={protec_logo_white}
          style={{ width: "35px", margin: "1%" }}
        />
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ display: { xs: 'none', sm: 'block' } }}
        >
          PROTEC
        </Typography>

        
  
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={() => setOpen(true)}
                color="inherit"
              >
                <ScheduleIcon/>
                <Typography margin={"auto"} marginRight={3} marginLeft={1}>{t("changeDateHistory")}</Typography> 
          
         
            </IconButton>
          </Box>
        <FormControl variant="standard" sx={{ minWidth: 120, color: "inherit" }}>
            <InputLabel id="language-picker-label" sx={{ color: "white" }}>
              {t("language")}
            </InputLabel>
            <Select
              labelId="language-picker-label"
              id="language-picker"
              value={language}
              onChange={handleLanguageChange}
              sx={{ color: "white", borderBottom: "1px solid white" }}
            >
            
              <MenuItem value="English">
              <img
                src={en_flag}
                alt="English"
               style={{ width: 20, marginRight: 8 }}
            />
              EN</MenuItem>
              <MenuItem value="Detusch">
              <img
                src={de_flag}
                alt="English"
               style={{ width: 20, marginRight: 8 }}
            />
              
              DE</MenuItem>
              <MenuItem value="Polski">
              <img
                src={pl_flag}
                alt="Poland"
               style={{ width: 20, marginRight: 8 }}
            />
              
              PL</MenuItem>
            </Select>
          </FormControl>

        {isAuthenticated && (
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                {accountName !== undefined ? <Typography margin={"auto"} marginRight={2}>  {accountName}</Typography> : null}
          
              <AccountCircle />
            </IconButton>
          </Box>
          
        )}

        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
          <IconButton
            size="large"
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="inherit"
          >
            <MoreIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
    {renderMobileMenu}
    {renderMenu}
  </Box>
  
  );
}

